import axios from 'axios';
import { addNotification, NotificationImportance } from '../common/commonActions';

/**
 * Actions
 */
export const Actions = {
    ADD_FICHIER_SUCCESS: 'ADD_FICHIER_SUCCESS',
    ADD_FICHIER_FAILURE: 'ADD_FICHIER_FAILURE',

    REMOVE_FICHIER_SUCCESS: 'REMOVE_FICHIER_SUCCESS',
    REMOVE_FICHIER_FAILURE: 'REMOVE_FICHIER_FAILURE',

    FETCH_FICHIER_SUCCESS: 'FETCH_FICHIER_SUCCESS',
    FETCH_FICHIER_FAILURE: 'FETCH_FICHIER_FAILURE',

    DOWNLOAD_FICHIER_SUCCESS: 'DOWNLOAD_FICHIER_SUCCESS',
    DOWNLOAD_FICHIER_FAILURE: 'DOWNLOAD_FICHIER_FAILURE'
};

/*
 * Add Fichier
 * Retourne l'id du fichier
 */
const addFichierSuccess = () => ({ type: Actions.ADD_FICHIER_SUCCESS });
const addFichierFailure = error => ({ type: Actions.ADD_FICHIER_FAILURE, error });

export const addFichier = file => async (dispatch) => {
    try {
        let formData = new FormData();
        formData.append('file', file);

        let response = await axios.post('api/fichiers', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        dispatch(addFichierSuccess());
        return response.data;
    } catch (error) {
        dispatch(addFichierFailure());
        addNotification(`Impossible d'ajouter le fichier ${file.name}`, NotificationImportance.error);
    }
};

/*
 * Remove Fichier
 * Retourne l'id du fichier
 */
const removeFichierSuccess = () => ({ type: Actions.REMOVE_FICHIER_SUCCESS });
const removeFichierFailure = error => ({ type: Actions.REMOVE_FICHIER_FAILURE, error });

export const removeFichier = id => async (dispatch) => {
    try {
        await axios.delete(`api/fichiers/${id}`);
        dispatch(removeFichierSuccess());
    } catch (error) {
        dispatch(removeFichierFailure());
        addNotification(`Impossible de supprimer le fichier ${id}`, NotificationImportance.error);
    }
};

/*
 * Fetch Fichier
 * Retourne les informations du fichier
 */
const fetchFichierSuccess = () => ({ type: Actions.FETCH_FICHIER_SUCCESS });
const fetchFichierFailure = error => ({ type: Actions.FETCH_FICHIER_FAILURE, error });

export const fetchFichier = id => async (dispatch) => {
    try {
        let response = await axios.get(`api/fichiers/${id}`);
        dispatch(fetchFichierSuccess());
        return response.data;
    } catch (error) {
        dispatch(fetchFichierFailure());
        addNotification(`Impossible de récupérer les informations sur le fichier ${id}`, NotificationImportance.error);
    }
};

/*
 * Download Fichier
 * Retourne les informations du fichier
 */
const downloadFichierSuccess = () => ({ type: Actions.DOWNLOAD_FICHIER_SUCCESS });
const downloadFichierFailure = error => ({ type: Actions.DOWNLOAD_FICHIER_FAILURE, error });

export const downloadFichier = id => async (dispatch) => {
    try {
        let response = await axios.get(`api/fichiers/${id}/download`, { responseType: 'blob' });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        var contentDisposition = response.headers['content-disposition'];
        var regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

        var match = regex.exec(contentDisposition);
        
        let filename = match[1]; // On prend le groupe 1
               
        link.setAttribute('download', decodeURIComponent(filename));

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        dispatch(downloadFichierSuccess());

        return true;
    } catch (error) {
        dispatch(downloadFichierFailure());
        dispatch(addNotification(`Impossible de télécharger le fichier ${id}`, NotificationImportance.error));
        return false;
    }
};